// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_1cdu3","content":"content_n3yl7","carousel":"carousel_4h8JB","questions":"questions_1XLZ6","navigation":"navigation_3eOFn"};